export const appAddIcon = {
  data: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1416_4446)"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 13V19H13V21H19V27H21V21H27V19H21V13H19Z" fill="currentColor"/></g><defs><clipPath id="clip0_1416_4446"><rect width="24" height="24" fill="white" transform="translate(8 8)"/></clipPath></defs></svg>`,
  name: 'add',
};
